import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { FindResultType } from 'owa-recipient-types/lib/types/FindControlViewState';
import { mutatorAction } from 'satcheljs';

/**
 * Clears the recipient well
 */
export default mutatorAction('resetRecipientWell', function(
    recipientWell: RecipientWellWithFindControlViewState
) {
    if (recipientWell) {
        // Clear query string from input field.
        recipientWell.queryString = '';

        // Reset the FindResultType
        recipientWell.findResultType = FindResultType.None;
    }
});
